import { useQuery } from "@tanstack/react-query";
import { chatApi } from "../../api/chat";
import { renderSchema, GetReaderItem } from "../../types/chat";

export const useGetReader = (params: renderSchema, enabled = true) => {
  return useQuery<{ Data: GetReaderItem[] }>({
    queryKey: ["reader", params.roomId, params.seen, params.read],
    queryFn: () => chatApi.getReader(params),
    enabled: enabled && !!params.roomId,
    staleTime: 0, // Luôn coi dữ liệu là stale
    refetchOnMount: "always", // Luôn refetch khi component mount
  });
};
